var map = {
	"./modules/administration/administration.module": [
		"./src/app/modules/administration/administration.module.ts",
		"common",
		"modules-administration-administration-module"
	],
	"./modules/application/application.module": [
		"./src/app/modules/application/application.module.ts",
		"common",
		"modules-application-application-module"
	],
	"./modules/auth/auth.module": [
		"./src/app/modules/auth/auth.module.ts",
		"common",
		"modules-auth-auth-module"
	],
	"./modules/users/users.module": [
		"./src/app/modules/users/users.module.ts",
		"modules-users-users-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;